import React from 'react';

import { Box, Stack } from '@mui/material';

import type { StatusCampaignPayloadBuilderState } from '~/utils/societePayloadBuilder/statusCampaign/types';

import { PAYLOAD_BUILDER_REQUIRED_FIELDS_SX } from '../FieldLabels';
import LoadPayloadSection from '../LoadPayloadSection';

import StatusClaimForm from './StatusClaimForm';
import StatusMatchForm from './StatusMatchForm';

interface StatusCampaignPayloadBuilderFormProps {
  state: StatusCampaignPayloadBuilderState;
  onChange: (next: StatusCampaignPayloadBuilderState) => void;
  loadJson: string;
  onLoadJsonChange: (value: string) => void;
  loadError: string | null;
  loadCollapseKey?: number;
  onLoadPayload: () => void;
  onClearLoad: () => void;
  onUploadFile: (file: File) => void;
}

export default function StatusCampaignPayloadBuilderForm({
  state,
  onChange,
  loadJson,
  onLoadJsonChange,
  loadError,
  loadCollapseKey,
  onLoadPayload,
  onClearLoad,
  onUploadFile,
}: StatusCampaignPayloadBuilderFormProps) {
  return (
    <Stack spacing={2}>
      <LoadPayloadSection
        loadJson={loadJson}
        loadError={loadError}
        collapseKey={loadCollapseKey}
        onLoadJsonChange={onLoadJsonChange}
        onLoadPayload={onLoadPayload}
        onClearLoad={onClearLoad}
        onUploadFile={onUploadFile}
      />

      <Box sx={PAYLOAD_BUILDER_REQUIRED_FIELDS_SX}>
        {state.mode === 'statusMatch' ? (
          <StatusMatchForm state={state} onChange={onChange} />
        ) : (
          <StatusClaimForm state={state} onChange={onChange} />
        )}
      </Box>
    </Stack>
  );
}
